<template>
    <div v-show="meta" class="filter" :class="`type-${meta.code}`">
        <DxTextBox
            :label="meta?.searchTitle"
            label-mode="floating"
            :show-clear-button="true"
            v-model:value="pattern"
            @enter-key="loadNodes"
        />
    </div>
    <ul class="tree-node">
        <li v-for="node in nodes" :key="node.id" @click="selectNode($event, node)" class="li-node">
            <div class="node">
                {{ node.name }}
            </div>
            <TreeNode :meta="meta.childMeta" :parent_id="node.id" />
        </li>
    </ul>
</template>

<script setup>
import { ref, defineProps, onMounted } from 'vue';

import { DxTextBox } from 'devextreme-vue/text-box';

const props = defineProps({
    meta: {
        type: Object,
        required: true,
    },
    callbacks: {
        type: Object,
        required: true,
    },
    parent_id: {
        type: String,
        required: false,
    },
});

const nodes = ref([]);
const pattern = ref(null);
const selected = ref(null);

onMounted(async () => {
    console.log(nodes.value);
    if (props.parent_id === null) {
        await loadNodes();
    }
});

const loadNodes = async () => {
    console.log('tree-node', pattern.value);
    if (props.meta) {
        nodes.value = await props.meta.load(props.parent_id, pattern.value);
    }
};

const selectNode = (event, nodeData) => {
    event.stopPropagation();
    console.log('tree-node.selectNode:', event, nodeData);
    selected.value = nodeData;
    const prevSelected = document.querySelector('.tree-node li.selected');
    if (prevSelected) prevSelected.classList.remove('selected');
    event.srcElement.parentElement.classList.add('selected');
    return false;
};
</script>

<style lang="scss" scoped>
.tree-node {
    list-style-type: none;
    padding-left: 20px;
}

li.selected > .node {
    background-color: #0078ff;
}

.filter {
    display: none;
}

.type-org.filter {
    display: block;
}

li.selected > .filter {
    display: block;
}

.node {
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    transition: background 0.2s;
}

.node:hover {
    background: #f0f0f0;
}

.node.has-children {
    color: #0078ff;
    font-weight: bold;
}

.spinner {
    margin-left: 8px;
    font-size: 0.9em;
    color: #888;
}
</style>
